var app = angular.module("nms.dynamicDevice");

app.directive("multipleValues",
    function() {
        return {
            restrict: "E",
            templateUrl: "templates/features/dynamic-device/domain/yang/leaf/types/multiple-values.html"
        };
    }
);
